export const state = {
  userInfo: null,
  jwt: null,
  userIsLoggedIn: false,
};

export default state;
